export const VARIANTS = {
    econsulting: {
        borderHex: "0199D5",
        logo: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/napis_logo_120x180.png",
            href: "https://econsulting.co/",
        },
        linkedin: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/linkedin-2.png",
            href: "https://linkedin.com/company/econsulting",
        },
        facebook: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/facebook-3.png",
            href: "https://www.facebook.com/eConsulting-120032234681381/",
        },
        youtube: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/youtube.png",
            href: "https://www.youtube.com/channel/UCuHe1I-xE4dKVN9BLh9C1hg",
        },
    },
    ecvalidation: {
        borderHex: "0d1026",
        logo: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/logo-ecvalidation-120x180-1.png",
            href: "https://ecvalidation.com/",
        },
        linkedin: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/logo-linkedin-72x72-1.png",
            href: "https://www.linkedin.com/company/ecvalidation/",
        },
        facebook: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/logo-facebook-72x72-1.png",
            href: "https://www.facebook.com/eConsulting-120032234681381/",
        },
        youtube: {
            src: "https://econsulting.co/wp-content/uploads/2023/03/logo-youtube-72x72-1.png",
            href: "https://www.youtube.com/channel/UCFdtjdxEXA_FeWgrmfZ1UHA",
        },
    },
};
